import React from "react";
import "./samanehWeb.style.sass";
import { Button, Col, Icon, Row } from "rsuite";
import { connect } from "react-redux";
import {
  ChangeActiveLink,
  SetTrackSystem,
} from "../../redux/site/site.actions";
import { createStructuredSelector } from "reselect";
import { selectTrackSystem } from "../../redux/site/site.selector";
import Axios from "axios";
import { Setting } from "../../setting";
import GridLoader from "react-spinners/GridLoader";
import { css } from "@emotion/react";
import { withRouter } from "react-router-dom";

class SamanehWeb extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      apiRes: "https://gps.xitonix.com/",
      showTestPanel: 0,
    };
  }

  componentDidMount() {
    const { setTrackSystem } = this.props;

    Axios.get(`${Setting.apiUrl}api/tracker/list`)
      .then(res => {
        setTrackSystem(res.data);
      })
      .catch(err => {});

    Axios.get(`${Setting.apiUrl}api/setting/list`)
      .then(res => {
        this.setState({
          apiRes: res.data.track_plan_address,
          showTestPanel: res.data.show_test_panel,
        });
      })
      .catch(err => {});
  }

  render() {
    const { changeActive, Data, history } = this.props;
    const { apiRes } = this.state;

    const override = css`
      display: block;
      margin: 40px auto;
      border-color: red;
      position: relative;
    `;

    return (
      <div className="samaneh-web">
        <div className="all-samaneh">
          {Data ? (
            <Row>
              <Col md={12} sm={24}>
                <div className="samaneh-vid-div">
                  {Data ? (
                    <video autoPlay loop muted>
                      <source
                        src={`${Setting.apiUrl}${Data[0].video}`}
                        type="video/mp4"
                      />
                    </video>
                  ) : null}
                </div>
              </Col>
              <Col md={12} sm={24}>
                <div className="samaneh-texts">
                  <div className="samaneh-div">
                    {Data ? (
                      <div>
                        <h4>{Data[0].title}</h4>
                        <p>{Data[0].description}</p>
                      </div>
                    ) : null}
                    <div className="samaneh-btns">
                      <a target="_blank" rel="noreferrer" href={`${apiRes}`}>
                        <Button>
                          <Row>
                            <Col className="padding-col gray-col" xs={16}>
                              <span style={{ fontWeight: "500" }}>
                                پنل ردیابی
                              </span>
                            </Col>
                            <Col
                              className="btn-marker"
                              xs={8}
                              style={{ backgroundColor: "rgb(100,100,100)" }}
                            >
                              <Icon icon="map-marker" />
                            </Col>
                          </Row>
                        </Button>
                      </a>
                      {Number(this.state.showTestPanel) === 1 && (
                        <a
                          target="_blank"
                          rel="noreferrer"
                          href={`${apiRes}?phone=+989190191914&pass=12345`}
                        >
                          <Button>
                            <Row>
                              <Col className="padding-col" xs={14}>
                                <span style={{ fontWeight: "500" }}>
                                  تست پنل ردیابی
                                </span>
                              </Col>
                              <Col
                                className="btn-marker"
                                xs={10}
                                style={{ backgroundColor: "#fc8b2b" }}
                              >
                                <Icon icon="map-o" />
                              </Col>
                            </Row>
                          </Button>{" "}
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          ) : (
            <div>
              <GridLoader css={override} size={15} margin={8} color="#FF8F3C" />
            </div>
          )}
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = dispatch => ({
  changeActive: active => dispatch(ChangeActiveLink(active)),
  setTrackSystem: data => dispatch(SetTrackSystem(data)),
});
const mapStateToProps = createStructuredSelector({
  Data: selectTrackSystem,
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SamanehWeb)
);
